"use strict";
var ɵngcc0 = require('@angular/core');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var AssetsAuthInterceptor = /** @class */ (function () {
    function AssetsAuthInterceptor() {
    }
    /**
     * Get the auth token from the service.
     * Clone the request and replace the original headers with
     * cloned headers, updated with the authorization.
     * send cloned request with header to the next handler.
     * @param req
     * @param next
     */
    AssetsAuthInterceptor.prototype.intercept = function (req, next) {
        if (req.url.includes("assets-api") || req.url.includes("localhost:51742")) {
            var token = localStorage.getItem("id_token_delegate_assets-api");
            var authReq = req.clone({ headers: req.headers.set('Authorization', "Bearer " + token) });
            var returnMimeReq_1 = authReq.clone({ headers: authReq.headers.set('Content-Type', 'application/json') });
            return next.handle(returnMimeReq_1);
        }
        var returnMimeReq = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
        return next.handle(req);
    };
    AssetsAuthInterceptor = __decorate([ __metadata("design:paramtypes", [])
    ], AssetsAuthInterceptor);
AssetsAuthInterceptor.ɵfac = function AssetsAuthInterceptor_Factory(t) { return new (t || AssetsAuthInterceptor)(); };
AssetsAuthInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AssetsAuthInterceptor, factory: function (t) { return AssetsAuthInterceptor.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AssetsAuthInterceptor, [{
        type: core_1.Injectable
    }], function () { return []; }, null); })();
    return AssetsAuthInterceptor;
}());
exports.AssetsAuthInterceptor = AssetsAuthInterceptor;
var AssetsAuthInterceptorModule = /** @class */ (function () {
    function AssetsAuthInterceptorModule() {
    }
AssetsAuthInterceptorModule.ɵfac = function AssetsAuthInterceptorModule_Factory(t) { return new (t || AssetsAuthInterceptorModule)(); };
AssetsAuthInterceptorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AssetsAuthInterceptorModule });
AssetsAuthInterceptorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: http_1.HTTP_INTERCEPTORS, useClass: AssetsAuthInterceptor, multi: true }
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AssetsAuthInterceptorModule, [{
        type: core_1.NgModule,
        args: [{
                providers: [
                    { provide: http_1.HTTP_INTERCEPTORS, useClass: AssetsAuthInterceptor, multi: true }
                ]
            }]
    }], function () { return []; }, null); })();
    return AssetsAuthInterceptorModule;
}());
exports.AssetsAuthInterceptorModule = AssetsAuthInterceptorModule;

